import { Loader2, Shield } from "lucide-react";
import { useState } from "react";
import { Banner, Button, Card } from "@/components/ui";
import { supabase } from "@/lib/supabase";

export function LoginPage() {
  const [loading, setLoading] = useState(false);
  const signIn = async () => {
    if (!supabase) return;
    setLoading(true);
    try {
      await supabase.auth.signInWithOAuth({
        provider: "google",
        options: { redirectTo: window.location.origin },
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <main className="grid min-h-screen place-items-center bg-radial-[circle_at_top] from-accent-glow to-background to-48%">
      <Card className="grid w-[min(440px,calc(100vw-32px))] gap-3.5 p-7">
        <div className="grid size-13 place-items-center rounded-full bg-primary font-bold text-primary-foreground">S</div>
        <h1 className="mb-1 text-[28px]">Synapse Agent Manager</h1>
        <p className="mb-4">Sign in with an admin Google account to edit agents, prompts, and QA data.</p>
        {!supabase && (
          <Banner tone="error">
            SAMS 로그인 설정이 없습니다. VITE_SUPABASE_PUBLISHABLE_KEY(SAMS Supabase 프로젝트 키)를 넣고 다시 빌드해 주세요.
          </Banner>
        )}
        <Button onClick={signIn} disabled={loading || !supabase}>
          {loading ? <Loader2 className="animate-spin" /> : <Shield />}
          Sign in with Google
        </Button>
      </Card>
    </main>
  );
}
